import { useState } from 'react'
import { Grid } from '@mui/material'
import styled from 'styled-components'
import { TextBody1Medium } from '../Styles/TextCustom'
import { useTranslation } from 'react-i18next'
import { themeColors } from '../../const/colors'
import {
  IRemoveAccessCardForUserData,
  IRemoveAccessCardForUserVars,
  REMOVE_ACCESS_CARD_FOR_USER,
} from '../../graphql/users/removeAccessCardForUser'
import { BaseTextButton } from '../Shared/BaseButton'
import BaseModal from '../Shared/BaseModal'
import { ApolloError, useMutation } from '@apollo/client'
import Error from '../Shared/Error'
import { Alert } from '@mui/material'

const UnassignUserAccessCard = ({
  login,
  refetch,
}: {
  login: string
  refetch: () => void
}) => {
  const { t } = useTranslation(['user_details'])
  const [openModal, setOpenModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const onError = (err: ApolloError) => setErrorMessage(err.message)
  const [unassignAccessCard] = useMutation<
    IRemoveAccessCardForUserData,
    IRemoveAccessCardForUserVars
  >(REMOVE_ACCESS_CARD_FOR_USER, {
    onCompleted: (data: IRemoveAccessCardForUserData) => {
      const { status, message, error } = data.removeAccessCardForUser
      if (!status) {
        setErrorMessage(message || error || '')
        return
      }
      setOpenModal(false)
      refetch()
    },
    onError,
    variables: { login },
  })

  const handleUnassignAccessCard = () => setOpenModal(true)

  return (
    <>
      <Container>
        <BaseTextButton
          onClick={handleUnassignAccessCard}
          customColor={themeColors.negative}
        >
          {t('remove_card')}
        </BaseTextButton>
        {errorMessage && <Error errorMessage={errorMessage} />}
      </Container>
      <BaseModal
        confirmText={t('btn:confirm')}
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleAccept={unassignAccessCard}
      >
        <Container>
          <Text>{t('remove_card_confirmation')}</Text>
          <AlertStyled severity="error">
            {t('parking_pool:unassign_card_warning')}
          </AlertStyled>
        </Container>
      </BaseModal>
    </>
  )
}

export default UnassignUserAccessCard
const Text = styled(TextBody1Medium)`
  display: inline;
`
const Container = styled(Grid)`
  padding: 16px;
`
const AlertStyled = styled(Alert)`
  margin: 16px 0;
`
